import { DataType, Tool } from '@/util/index'
const tool = new Tool()
const state = {
  loan: {},
  program: null,
  lockReason: null,
  hasPaymentSchedule: false,
  portfolioJson: {},
  paymentSchedule: [],
  portfolioId: '',
  portfolioArrayWithEmployeeId: [],
  portfolioArray: [],
  languageCode: '',
  isPersonalRemote: false,
  questionAppendix: '',
  runtimePortfolio: [],
  runtimePortfolioArray: [],
  loanOperation: null,
  currentLoan: {},
  relatedLoans: [],
  manualCreateLeadId: {},
  latestPersonalStamp: null,
  cardNo: null,
  chirpRequestData: {},
  chirpRequestStatus: {}
}

const getters = {
  getLoan: (state) => state.loan,
  getProgram: (state) => state.program,
  getLockReason: (state) => state.lockReason,
  getHasPaymentSchedule: state => state.hasPaymentSchedule,
  getPortfolioJson: state => state.portfolioJson,
  getPaymentSchedule: state => state.paymentSchedule,
  getPortfolioId: state => state.portfolioId,
  getPortfolioArrayWithEmployeeId: state => state.portfolioArrayWithEmployeeId,
  getPortfolioArray: state => state.portfolioArray,
  getLanguageCode: state => state.languageCode,
  getPersonalRemote: state => state.isPersonalRemote,
  getQuestionAppendix: state => state.questionAppendix,
  getRuntimePortfolio: state => state.runtimePortfolio,
  getRuntimePortfolioArray: state => state.runtimePortfolioArray,
  getLoanOperation: state => state.loanOperation,
  getCurrentLoan: state => state.currentLoan,
  getRelatedLoans: state => state.relatedLoans,
  getManualCreateLeadId: state => state.manualCreateLeadId,
  getLatestPersonalStamp: state => state.latestPersonalStamp,
  getCardNo: (state) => state.cardNo,
  getChirpRequestData: (state) => state.chirpRequestData,
  getChirpRequestStatus: (state) => state.chirpRequestStatus
}

const actions = {}

const mutations = {
  setCurrentLoan (state, data) {
    state.currentLoan = data
  },
  setRuntimePortfolioArray (state, data) {
    state.runtimePortfolioArray = data
  },
  setRuntimePortfolio (state, data) {
    state.runtimePortfolio = data
  },
  setPortfolioId (state, data) {
    state.portfolioId = data
  },
  setPortfolioJson (state, data) {
    state.portfolioJson = data
  },
  setLoan (state, data) {
    const loanData = data.loan
    const sectionName = data.sectionName
    let loan = {}
    if (sectionName === 'statement') {
      loan.statement = loanData
    } else {
      loan = loanData
    }
    state.loan = Object.assign(state.loan, loan)
  },
  clearLoan (state) {
    state.loan = {}
  },
  setProgram (state, program) {
    state.program = program
  },
  setLockReason (state, lockReason) {
    state.lockReason = lockReason
  },
  setHasPaymentSchedule (state, hasPaymentSchedule) {
    state.hasPaymentSchedule = hasPaymentSchedule
  },
  setPaymentSchedule (state, data) {
    state.paymentSchedule = data
  },
  clearPaymentSchedule (state) {
    state.paymentSchedule = []
  },
  setPortfolioArrayWithEmployeeId (state, data) {
    state.portfolioArrayWithEmployeeId = data
  },
  setPortfolioArray (state, data) {
    state.portfolioArray = data
  },
  setLanguageCode (state, data) {
    let language = ''
    if (tool.isNotEmpty(data)) {
      language = DataType.Language.find(language => {
        return data.language === language.value
      })
    }
    state.languageCode = tool.isEmpty(language) ? 'GB' : language.code
  },
  setPersonalRemote (state, data) {
    state.isPersonalRemote = tool.isNotEmpty(data) && data.code === DataType.StampReasonEnum.PERSONAL_REMOTE_CONSENT.value
  },
  setLatestPersonalStamp (state, data) {
    state.latestPersonalStamp = data
  },
  setQuestionAppendix (state, data) {
    state.questionAppendix = data
  },
  setLoanOperation (state, data) {
    state.loanOperation = data
  },
  setRelatedLoans (state, relatedLoans) {
    state.relatedLoans = relatedLoans
  },
  setManualCreateLeadId (state, manualCreateLeadId) {
    state.manualCreateLeadId = manualCreateLeadId
  },
  setCardNo (state, data) {
    state.cardNo = data
  },
  setProvider (state, data) {
    state.provider = data
  },
  setChirpRequestData (state, data) {
    state.chirpRequestData = data
  },
  setChirpRequestStatus (state, data) {
    state.chirpRequestStatus = data
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
